import { CustomerFeedbackSubmit, EReviewLink, FilteredCreditApplication } from '@applyonline/shared'
import { EFinancingProgram } from '@if/core/types'
import { isMedicardLoanPurpose } from '../../../data/merchant-selectors'
import { useTranslation } from 'react-i18next'

interface Props {
  creditApp: FilteredCreditApplication
}
const CompletedAppPage = ({ creditApp }: Props) => {
  const { t } = useTranslation()
  const msg = creditApp.loanCreated ? 'common.loanCreated' : 'common.awaitingContractReview'
  
  const reviewLink = isMedicardLoanPurpose(creditApp.loanPurposeId) ? EReviewLink.Medicard : EReviewLink.IFinance
  
  return (
    <main className="general-message">
      <h4 className="subtitle">{t('common.goodNews')}</h4>
      <div>
        <h3>{t(msg)}</h3>
      </div>
      <CustomerFeedbackSubmit 
        creditApp={creditApp} 
        reviewLink={reviewLink}
        financingProgram={EFinancingProgram.Personal} 
      />
    </main>
  )
}

export default CompletedAppPage
